module.exports = __webpack_public_path__ + "img/before_after_flexsale_2.966c0501.png";